<template>
    <tooltip :content="getStatusAdditionalInfo()" method="hover" class="align-middle">
        <badge :type="getTypeBasedOnStatus()" :title="getTextBasedOnStatus()"/>
    </tooltip>
</template>

<script>
import Badge from "../../elements/Badge.vue";

export default {
    name: "ReferralStatus",
    components: {Badge},
    props: ['activity', 'status', 'archived', 'translations'],
    computed: {
        is_archived() {
            return this.archived === true || this.archived === 1 || this.archived === '1'
        }
    },
    methods: {
        getStatusAdditionalInfo() {
            if (this.activity) {
                if (this.activity.status_additional_info?.fraud_detection?.reason) {
                    return this.activity.status_additional_info.fraud_detection.reason;
                } else if(this.activity.status_additional_info?.rejection_data?.reason) {
                    return this.activity.status_additional_info.rejection_data.reason;
                }
            }

            return null;
        },
        getTypeBasedOnStatus() {

            if (this.status === 'refunded') {
                return 'error';
            }

            if (this.is_archived) {
                return 'error';
            }

            switch (this.status) {
                case 'paid':
                    return 'success'
                case 'pending_for_approval':
                case 'review_period':
                case 'pre_commission_period':
                case 'requested':
                    return 'pending'
                case 'suspended':
                case 'fraudulent':
                case 'rejected':
                case 'deleted':
                case 'insufficient_settings':
                case 'post_commission_period':
                    return 'error'
                case 'ok':
                case 'unpaid':
                case 'active':
                default:
                    return 'neutral'
            }
        },
        getTextBasedOnStatus() {

            if (this.status === 'refunded') {
                return 'Refunded';
            }

            if (this.is_archived) {
                return 'Archived';
            }

            switch (this.status) {
                case null:
                    return 'n/a'
                case 'ok':
                    return 'OK'
                case 'paid':
                    return 'Paid'
                case 'unpaid':
                    return 'Unpaid'
                case 'deleted':
                    return 'Archived'
                case 'active':
                    return 'Active'
                case 'suspended':
                    return 'Suspended'
                case 'pending_for_approval':
                    return 'Pending for approval'
                case 'review_period':
                    return (this.translations && this.translations.portal_translation_features_reward_in_review) || 'Reward in review'
                case 'insufficient_settings':
                    return 'Insufficient settings'
                case 'post_commission_period':
                    return 'Post commission period'
                case 'pre_commission_period':
                    return 'Not started'
                case 'post_claim_period':
                    return 'Post claim period'
                case 'rejected':
                    return 'Rejected'
                default:
                    return this.status.charAt(0).toUpperCase() + this.status.slice(1);
            }
        }
    }
}
</script>
